const mean = 0;
const stdDev = 1;

const generateBellCurve = () => {
  const data = [];
  for (let x = -3; x <= 3; x += 0.1) {
    const y =
      (1 / (stdDev * Math.sqrt(2 * Math.PI))) *
      Math.exp(-0.8 * Math.pow((x - mean) / stdDev, 2));
    data.push([x, y]);
  }
  return data;
};

export const Chartconfig = {
  chart: {
    spacing: [20, 20, 50, 20],
    height: 250,
  },
  title: {
    text: "",
  },
  legend: {
    enabled: false,
  },
  tooltip: {
    enabled: false,
  },
  plotOptions: {
    series: {
      enableMouseTracking: false,
    },
    line: {
      marker: {
        enabled: false,
      },
    },
  },
  xAxis: {
    plotBands: [
      {
        from: -3,
        to: -1.5,
        label: {
          text: "คนที่ต่ำกว่าค่าเฉลี่ย",
          align: "center",
          verticalAlign: "bottom",
          y: 30,
          style: {
            color: "#000000",
            fontSize: "10px",
            fontFamily: "Kanit",
          },
        },
      },
      {
        from: -2,
        to: 2,
        label: {
          text: "คนที่อยู่ในค่าเฉลี่ย",
          align: "center",
          verticalAlign: "bottom",
          y: 30,
          style: {
            color: "#000000",
            fontSize: "10px",
            fontFamily: "Kanit",
          },
        },
      },
      {
        from: 1,
        to: 4,
        label: {
          text: "คนที่สูงกว่าค่าเฉลี่ย",
          align: "center",
          verticalAlign: "bottom",
          y: 30,
          style: {
            color: "#000000",
            fontSize: "10px",
            fontFamily: "Kanit",
          },
        },
      },
    ],
    plotLines: [
      {
        color: "black",
        width: 2,
        value: -1.5,
        zIndex: 5,
      },
      {
        color: "black",
        width: 2,
        value: 1.5,
        zIndex: 5,
      },
    ],
    labels: {
      enabled: false,
    },
  },
  yAxis: {
    title: {
      text: "",
    },
    labels: {
      enabled: false,
    },
    gridLineWidth: 0,
  },
  series: [
    {
      data: generateBellCurve(),
      type: "spline",
      color: "#3333cc",
      animation: false,
      marker:{
        enabled: false,
      }
    },
  ],
};

export const markPos = (position) => {
  const conf = {
    ...Chartconfig,
    series: [Chartconfig.series[0]],
  };
  let x = 0;
  switch (position) {
    case 'slower':
      x = -2
      break;
    case 'faster':
      x = 2;
      break;
    default:
  }

  conf.series.push({
      type: "scatter", // This series is for the dot
      data: [[x, 0.1]],
      marker: {
        symbol: "circle",
        radius: 6,
        fillColor: "red",
      },
      dataLabels: {
        enabled: true,
        format: "คุณอยู่ที่นี่",
        y: -15,
        style: {
          fontSize: "10px",
          fontFamily: "Kanit",
          color: "#000",
        },
      },
      animation: false,
      enableMouseTracking: false,
  })
  return conf
}